var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M9.76941 18.7896H1.14849C0.599657 18.7896 0.155029 18.3446 0.155029 17.796V1.783C0.155029 1.23424 0.599726 0.789551 1.14849 0.789551H17.1616C17.7103 0.789551 18.155 1.23424 18.155 1.783V17.796C18.155 18.3447 17.7102 18.7896 17.1616 18.7896H12.5748V11.819H14.9145L15.2648 9.1024H12.5748V7.36804C12.5748 6.58153 12.7932 6.04555 13.921 6.04555L15.3595 6.04493V3.61521C15.1107 3.5821 14.2568 3.50814 13.2634 3.50814C11.1893 3.50814 9.76941 4.77412 9.76941 7.099V9.1024H7.4237V11.819H9.76941V18.7896Z","fill":"white"}));
}

Facebook.defaultProps = {"width":"19","height":"19","viewBox":"0 0 19 19","fill":"none"};

module.exports = Facebook;

Facebook.default = Facebook;
